<script>
import Badge from "./Badge.vue";
import { getClaimStatusVariant, getClaimStatus } from "@/src/helpers/claim";

export default {
  name: "ClaimStatusBadge",
  props: {
    status: {
      type: String,
      required: true,
    },
  },
  components: {
    Badge,
  },
  computed: {
    variant() {
      return getClaimStatusVariant(this.status);
    },
    claimStatus() {
      return getClaimStatus(this.status);
    },
  },
};
</script>

<template>
  <Badge :variant="variant" :label="claimStatus" />
</template>
